import { render, staticRenderFns } from "./FormAssignments.vue?vue&type=template&id=6a0d5ea5"
import script from "./FormAssignments.vue?vue&type=script&lang=js"
export * from "./FormAssignments.vue?vue&type=script&lang=js"
import style0 from "./FormAssignments.vue?vue&type=style&index=0&id=6a0d5ea5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports